import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { govCertapplyActions } from '../../../../store/actions'

const ECDApplySupportListInquire = (props) => {
  const [state, setState] = useState({
    userSeCode: '1',
    docKndNm: '',
  })

  const [list, setList] = useState([])

  useEffect(() => {
    // 전자증명서 종류 및 관련 정보 목록 조회
    getList()
  }, [])

  useEffect(() => {
    if (props.list !== null && props.list !== undefined && props.list.length > 0) {
      const filterList =
        Array.isArray(props.list) &&
        props.list?.filter((info) => info.docKndNm === '사업자등록증명' || info.docKndNm === '운전경력증명서')
      setList(filterList)
    }
  }, [props.list])

  // 지갑 API 이용기관에서 실시간으로 전자증명서 유통 서비스가 지원하는 전자증명서 종류 및 관련 정보 목록 조회
  const getList = () => {
    const param = {}
    param.userSeCode = state.userSeCode
    param.docKndNm = state.docKndNm

    props.getAplySupportList(param)
  }

  // 신청현황 Click Evnet (popup)
  const openPopup = () => {
    props.showECDApplyPopup()
  }

  // 신청하기 Button Click Event
  const goAplyPage = (docKndCode, docKndNm) => {
    if (docKndNm === '운전경력증명서') {
      window.location.href = '/service/gov/edocwallet/drivers'
    } else {
      window.location.href = '/service/gov/edocwallet/business'
    }
  }

  // 증명서명 change Evnet
  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setState({
  //     ...state,
  //     [name]: value,
  //   })
  // }

  // 검색 Button Click Event (증명서명)
  // const search = () => {
  //   const param = {}
  //   param.userSeCode = state.userSeCode
  //   param.docKndNm = state.docKndNm
  //   console.log('param', param)

  //   props.getAplySupportList(param)
  // }

  return (
    <>
      <div className="nav-wrap" style={{ marginBottom: '20px' }}>
        <button className="btn-primary md" style={{ marginRight: '5px' }} onClick={getList}>
          신청목록
        </button>
        <button className="btn-secondary md" onClick={openPopup}>
          신청현황
        </button>
      </div>
      {/* 
        <div className="search-box center mt35">
          <div className="row">
            <span className="tit">검색어</span>
            <div className="inquiry-group">
              <input
                name="docKndNm"
                type="text"
                placeholder="증명서명을 입력하세요."
                className="form-keyword"
                onChange={handleChange}
              />
              <button type="button" className="btn-search" onClick={search}>
                검색
              </button>
            </div>
          </div>
        </div> 
      */}
      <ul className="list-board">
        {list?.length > 0
          ? list.map((info, index) => {
              return (
                <li key={info?.docKndCode ? info?.docKndCode : index}>
                  <div className="info">
                    <p className="txt">발급기관 : {info.issuInsttNm}</p>
                    <p className="tit">{info.docKndNm}</p>
                  </div>
                  <button type="button" className="btn-secondary md" onClick={() => goAplyPage(info.docKndCode, info.docKndNm)}>
                    신청하기
                  </button>
                </li>
              )
            })
          : '오류가 발생했습니다. \n 이 오류가 지속되면 관리자에게 문의하세요'}
      </ul>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    list: state.govcertapply.data,
  }
}

const actionCreators = {
  getAplySupportList: govCertapplyActions.getAplySupportList,
  showECDApplyPopup: govCertapplyActions.showECDApplyPopup,
}

export default connect(mapStateToProps, actionCreators)(ECDApplySupportListInquire)
